
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import type { OnboardingPath } from '@/types/whatsapp-onboarding';

export default defineComponent({
  name: 'WhatsappSituationStep',

  props: {
    modelValue: {
      type: String as PropType<OnboardingPath | null>,
      default: null,
    },
  },

  emits: ['update:modelValue'],

  setup() {
    const { t } = useI18n();
    const options = [
      {
        value: 'none' as OnboardingPath,
        labelKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.none.label',
        descriptionKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.none.description',
      },
      {
        value: 'other_bsp' as OnboardingPath,
        labelKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.otherBsp.label',
        descriptionKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.otherBsp.description',
      },
      {
        value: 'wa_app' as OnboardingPath,
        labelKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.waApp.label',
        descriptionKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.waApp.description',
      },
    ];
    return { t, options };
  },
});
